module.exports = __webpack_public_path__ + "static/media/finance_insurance.fa30088a.jpeg";